import type { FunctionComponent } from 'preact';

import { DisplayMode } from '../../../modules/serverApi/types';
import type { FacetCommonProps } from '../baseFacet';
import RangedListFacet from './rangedListFacet';
import RangedSliderFacet from './rangedSliderFacet';

const RangedFacet: FunctionComponent<FacetCommonProps> = ({ facet, ...props }) => {
  if (facet.displayMode === DisplayMode.Slider) {
    return <RangedSliderFacet facet={facet} {...props} />;
  } else if (facet.displayMode === DisplayMode.Ranges) {
    return <RangedListFacet facet={facet} {...props} />;
  }

  return null;
};

export default RangedFacet;
